import React, { Fragment, useState , useEffect} from "react";
import { Col, Card, Table, Modal, Button ,Form, Spinner} from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import Snackbars from "../../../utils/Snackbars";
import useRequests from "../../../utils/useRequests";
import DataTable from "react-data-table-component";
import { useFormik } from "formik";
import * as Yup from "yup";


const EventsList = () => {
    const location = useLocation();
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false); 
    const [showFeesModal, setShowFeesModal] = useState(false); 
    const [showBuyLimitModal, setShowBuyLimitModal] = useState(false); 
    const [modalType, setModalType] = useState(""); // "activate" or "deactivate"
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const { getRequest, deleteRequest, putRequest } = useRequests();
    const [searchQuery, setSearchQuery] = useState('');
    const [resellModalType, setResellModalType] = useState(""); // "activate" or "deactivate"
    const [resellShowModal, setResellShowModal] = useState(false);

    const [AlertData, setAlertData] = React.useState({
            variant: '',
            message: '',
          });
        
          const resetAlertData = () => {
            setTimeout(() => {
              setAlertData((AlertData) => ({
                ...AlertData,
                variant: '',
                message: '',
              }));
            }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
          };

          const fetchEvents = async () => {
                    const response = await getRequest("event-list"); // Replace "users" with the appropriate API endpoint
                    // const response = resultData[0]
                    if (response && response.code === 200) {
                      setEvents(response.data);
                      console.log(response.data)
                    } else {
                      console.error("Failed to fetch events:", response.message);
                      setAlertData((AlertData) => ({
                        ...AlertData,
                        variant: 'error',
                        message: 'Failed to fetch events',
                      }));
                    }
                    resetAlertData();
                    setLoading(false);
                  };
                
                  useEffect(() => {
                    fetchEvents();
                    if (location.state && typeof location.state.message !== 'undefined') {
                      setAlertData((AlertData) => ({
                        ...AlertData,
                        variant: location.state.status,
                        message: location.state.message,
                      }));
                      resetAlertData();
                      setLoading(false);
                    }
                  }, []);


     // Filter event  based on the search query
    const filteredEvent = events.filter((event) => {
        const city = `${event.city}`.toLowerCase();
        const name = `${event.name}`.toLowerCase();
        const status = `${event.status}`.toLowerCase();
        const organizer = `${event.first_name} ${event.last_name}`.toLowerCase();
        const searchLower = searchQuery.toLowerCase();
    
        return organizer.includes(searchLower) ||city.includes(searchLower) || status.includes(searchQuery) || name.includes(searchQuery);
    });

    const handleOpenModal = (event) => {
        setSelectedEvent(event);
        setModalType(event.status === "Enable" ? "disable" : "enable");
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setModalType("");
        setSelectedEvent(null);
    };

    const handleOpenResellModal = (event) => {
        setSelectedEvent(event);
        setResellModalType(event.resellstatus === "On" ? "Off" : "On");
        setResellShowModal(true);
    };

    const handleCloseResellModal = () => {
        setResellShowModal(false);
        setResellModalType("");
        setSelectedEvent(null);
    };

    const handleConfirmAction1 = async() => {
        if (selectedEvent) {
          setIsProcessing(true);
            // const updatedEvents = events.map((event) =>
            //     event.e_id === selectedEvent.e_id
            //         ? { ...event, status: modalType === "enable" ? "Enable" : "Disable" }
            //         : event
            // );
            // setEvents(updatedEvents);
            const newStatus = resellModalType === "On" ? "On" : "Off";

                try {
                    const jsonpar = JSON.stringify({ resellstatus: newStatus });
                    const response = await putRequest(`event-resellstatus/${selectedEvent.e_id}`, jsonpar);

                    if (response && response.code === 200) {
                    const updatedEvents = events.map((event) =>
                        event.e_id === selectedEvent.e_id ? { ...event, resellstatus: newStatus } : event
                    );
                    setEvents(updatedEvents);
                    setAlertData((AlertData) => ({
                        ...AlertData,
                        variant: 'success',
                        message: `Resell Event ${newStatus} successfully`,
                    }));
                    resetAlertData();
                    } else {
                    console.error("Failed to update status:", response?.message);
                    setAlertData((AlertData) => ({
                        ...AlertData,
                        variant: 'error',
                        message: `Failed to ${newStatus} resell event.`,
                    }));
                    resetAlertData();
                    }
                } catch (error) {
                    console.error("Error updating status:", error);
                    setAlertData((AlertData) => ({
                    ...AlertData,
                    variant: 'error',
                    message: 'Error updating resell status',
                    }));
                    resetAlertData();
                }
        }
        setIsProcessing(false);
        handleCloseResellModal();
    };

    const handleConfirmAction = async() => {
        if (selectedEvent) {
          setIsProcessing(true);
            // const updatedEvents = events.map((event) =>
            //     event.e_id === selectedEvent.e_id
            //         ? { ...event, status: modalType === "enable" ? "Enable" : "Disable" }
            //         : event
            // );
            // setEvents(updatedEvents);
            const newStatus = modalType === "enable" ? "Enable" : "Disable";

                try {
                    const jsonpar = JSON.stringify({ status: newStatus });
                    const response = await putRequest(`event-status/${selectedEvent.e_id}`, jsonpar);

                    if (response && response.code === 200) {
                    const updatedEvents = events.map((event) =>
                        event.e_id === selectedEvent.e_id ? { ...event, status: newStatus } : event
                    );
                    setEvents(updatedEvents);
                    setAlertData((AlertData) => ({
                        ...AlertData,
                        variant: 'success',
                        message: `Event ${newStatus}d successfully`,
                    }));
                    resetAlertData();
                    } else {
                    console.error("Failed to update status:", response?.message);
                    setAlertData((AlertData) => ({
                        ...AlertData,
                        variant: 'error',
                        message: `Failed to ${newStatus} event.`,
                    }));
                    resetAlertData();
                    }
                } catch (error) {
                    console.error("Error updating status:", error);
                    setAlertData((AlertData) => ({
                    ...AlertData,
                    variant: 'error',
                    message: 'Error updating status',
                    }));
                    resetAlertData();
                }
        }
        setIsProcessing(false);
        handleCloseModal();
    };
    const [isProcessing, setIsProcessing] = useState(false);
    const handleDeleteEvent = async() => {
        if (selectedEvent) {
          setIsProcessing(true);
            const response = await deleteRequest(`event-delete/${selectedEvent.e_id}`);
            if (response && response.code === 200) {
                const updatedEvents = events.filter((event) => event.e_id !== selectedEvent.e_id);
                setEvents(updatedEvents);
              setAlertData((AlertData) => ({
                ...AlertData,
                variant: 'success',
                message: 'Event deleted successfully!',
              }));
              resetAlertData();
            } else {
              console.error("Failed to delete event:", response?.message);
              setAlertData((AlertData) => ({
                ...AlertData,
                variant: 'error',
                message: 'Failed to delete event',
              }));
              resetAlertData();
        }
        setIsProcessing(false);
        setShowDeleteModal(false);
        }
    };

    const openDeleteModal = (event) => {
        setSelectedEvent(event);
        setShowDeleteModal(true);
    };

    const closeDeleteModal = () => {
        setShowDeleteModal(false);
        setSelectedEvent(null);
    };

    const openFeesModal = (event) => {
      const { admin_fees_percentage = "", admin_fees_percentage_max_amount = "", admin_fixed_fees = "", resale_admin_fees_percentage = "", resale_organizer_fees_percentage = "", platform_fees_type = "", platform_fees_percentage = "", platform_fees_fixed = "" } = event;
      setFormData({ admin_fees_percentage, admin_fees_percentage_max_amount, admin_fixed_fees, resale_admin_fees_percentage, resale_organizer_fees_percentage, platform_fees_type, platform_fees_percentage, platform_fees_fixed });

      setSelectedEvent(event);
      setShowFeesModal(true);
  };

  const closeFeesModal = () => {
      setShowFeesModal(false);
      setSelectedEvent(null);
  };

  const openBuyLimitModal = (event) => {
      const {one_transaction_buy_limit = ""} = event;
      setBuyLimitData({ one_transaction_buy_limit });

      setSelectedEvent(event);
      setShowBuyLimitModal(true);
  };

  const closeBuyLimitModal = () => {
      setShowBuyLimitModal(false);
      setSelectedEvent(null);
  };


      const columns = [
                {
                    name: "Organizer",
                    selector: (row) =>  `${row.first_name} ${row.last_name}`,
                    sortable: true,
                    width:"200px"
                   
                },
              {
                name: "Event",
                selector: (row) => row.name,
                sortable: true,
                // width:'350px'
                // whiteSpace:'normal !important'
              },
              {
                name: "City",
                selector: (row) => row.city,
                sortable: true,
                width:"200px"
              },
              
              {
                name: "Status",
                cell: (row) => (
                  <button
                    onClick={() =>
                      handleOpenModal(row, row.status === "Enable" ? "disable" : "enable")
                    }
                    className={`btn ${
                      row.status === "Enable" ? "btn-success" : "btn-danger"
                    } btn-xxs`}
                  >
                    {row.status === "Enable" ? "Enable" : "Disable"}
                  </button>
                ),
                center: true,
                width: "150px",
              },
              {
                name: "Actions",
                cell: (row) => (
                  <div className="text-center">
                    <Link className="btn btn-primary btn-xxs me-2" to={`/event-edit/${row.e_id}`} title="Edit Event">
                      <i className="fa-regular fa-pen-to-square"></i>
                    </Link>
                    <Link to={`/event-details/${row.e_id}`} className="btn btn-primary btn-xxs me-2" title="Event Details"> 
                        <i className="fa-regular fa-eye"></i> 
                    </Link>
                    <button className="btn btn-primary btn-xxs me-2" onClick={() => openFeesModal(row, 'fees')} title="Admin Fees">
                      <i className="fa-solid fa-money-bill-wave"></i>
                    </button>
                    <button className="btn btn-primary btn-xxs me-2" onClick={() => openBuyLimitModal(row)} title="Buy Limit">
                      <i className="fa-solid fa-ban"></i>
                    </button>
                    <button className="btn btn-primary btn-xxs me-2" onClick={() => handleOpenResellModal(row, row.resellstatus === "On" ? "Off" : "On")} title="Resell Status">
                      <i className="fa-solid fa-arrows-rotate"></i>
                    </button>
                    <button className="btn btn-danger btn-xxs" onClick={() => openDeleteModal(row, 'delete')} title="Delete Event">
                      <i className="fa-solid fa-trash"></i>
                    </button>
                  </div>
                ),
                center: true,
                width: "350px",
              },
            ];
          
    
    const customStyles = {
    header: {
        style: {
          whiteSpace:"normal",
        // minHeight: "56px",
        // flexBasis:'auto !important',
        },
    },
    headCells: {
        style: {
        // flexBasis:'auto !important',
        color: "#341439",
        fontSize: "17px",
        fontWeight: "600",
        textTransform: "capitalize",
        paddingLeft: "8px", // Adjust padding
        paddingRight: "8px",
        },
    },
    cells: {
        style: {
        // flexBasis:'auto !important',
        fontSize: "16px",
        padding: "12px 9px",
        color: "#7E7E7E",
        
        },
    },
    pagination: {
        style: {
        fontSize: "16px",
        },
    },
    "& .hmVlQg div:first-child": {
    whiteSpace: "normal !important",
},
    };
    
  const [buyLimitData, setBuyLimitData] = useState({
      one_transaction_buy_limit: "",
  });

  const validationSchema1 = Yup.object({
    one_transaction_buy_limit: Yup.string().required("Buy Limit is required"),
  });

      const formik1 = useFormik({
      initialValues: buyLimitData,

      enableReinitialize: true,
      validationSchema1,
      onSubmit: async (values) => {
          const jsonpar = JSON.stringify({
            one_transaction_buy_limit: values.one_transaction_buy_limit,
        });
        setIsProcessing(true);

          const response = await putRequest(`event-buy-limit-edit/${selectedEvent.e_id}`, jsonpar);
  
          if (response && response.code === 200) {
            
            setAlertData({ variant: "success", message: "Buy Limit updated successfully!" });
            resetAlertData();
            fetchEvents();
            closeBuyLimitModal();
            setIsProcessing(false);

          } else {
            setAlertData({ variant: "error", message: "Failed to update setting." });
            resetAlertData();
          }
      },
    });

    const [formData, setFormData] = useState({
      admin_fees_percentage: "",
      admin_fees_percentage_max_amount: "",
      admin_fixed_fees: "",
      resale_admin_fees_percentage: "",
      resale_organizer_fees_percentage: "",
      platform_fees_type: "",
      platform_fees_percentage: "",
      platform_fees_fixed: ""
  });

    const validationSchema = Yup.object({
      platform_fees_type: Yup.string().required("Platform Fee type is required"),
      platform_fees_percentage: Yup.string().required("Platform Fee is required"),
      platform_fees_fixed: Yup.string().required("Platform Fee is required"),
      admin_fees_percentage: Yup.string().required("Percentage Fee is required"),
      admin_fees_percentage_max_amount: Yup.string().required("Max order amount is required"),
      admin_fixed_fees: Yup.string().required("Fixed Fee is required"),
      resale_admin_fees_percentage: Yup.string().required("Resale Ticket Admin Fee is required"),
      resale_organizer_fees_percentage: Yup.string().required("Resale Ticket Organizer Fee is required"),
    });
  
    const formik = useFormik({
      initialValues: formData,

      enableReinitialize: true,
      validationSchema,
      onSubmit: async (values) => {
          const jsonpar = JSON.stringify({
            platform_fees_type: values.platform_fees_type,
            platform_fees_percentage: values.platform_fees_percentage,
            platform_fees_fixed: values.platform_fees_fixed,
            admin_fees_percentage: values.admin_fees_percentage,
            admin_fees_percentage_max_amount: values.admin_fees_percentage_max_amount,
            admin_fixed_fees: values.admin_fixed_fees,
            resale_admin_fees_percentage: values.resale_admin_fees_percentage,
            resale_organizer_fees_percentage: values.resale_organizer_fees_percentage
        });
        setIsProcessing(true);

          const response = await putRequest(`event-fees-edit/${selectedEvent.e_id}`, jsonpar);
  
          if (response && response.code === 200) {
            
            setAlertData({ variant: "success", message: "Fees updated successfully!" });
            resetAlertData();
            fetchEvents();
            closeFeesModal();
            setIsProcessing(false);

          } else {
            setAlertData({ variant: "error", message: "Failed to update setting." });
            resetAlertData();
          }
      },
    });


    return (
        
      <Fragment>
        <div className='d-sm-flex d-block justify-content-between align-items-center mb-4'>
          <h2 className='text-black font-w600 mb-0'>Events Management</h2>
          {AlertData.message !== "" ? (
            <Snackbars
              variant={AlertData.variant}
              message={AlertData.message}
            />
          ) : (
            ""
          )}
          <Link
            to='/event-add'
            type='button'
            className='btn btn-rounded btn-primary'
          >
            {" "}
            Add Event{" "}
          </Link>
        </div>

        {/* Search input */}
        <div className='mb-4 d-sm-flex d-block justify-content-end'>
          <div style={{position: "relative", width: "18rem"}}>
            <Form.Control
              type='text'
              placeholder='Search...'
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{
                width: "100%",
                fontSize: "18px",
                fontWeight: 500,
                paddingRight: "2rem",
                borderRadius: "0.625rem",
                height: "3.2rem", // Add padding to ensure the icon doesn't overlap text
              }}
            />
            <i
              className='fa fa-search'
              style={{
                position: "absolute",
                right: "10px", // Distance from the right edge of the input
                top: "50%",
                transform: "translateY(-50%)", // Center vertically
                color: "#6c757d", // Optional: color for the icon
                pointerEvents: "none", // Makes sure clicks pass through to the input
              }}
            ></i>
          </div>
        </div>
        <Col lg={12}> 
        <Card>
          <Card.Body>
            {loading ? (
              <div className='text-center'>
                <Spinner animation='border'variant="primary"  />
                <p>Loading settings...</p>
              </div>
            ) : (
              <DataTable
                columns={columns}
                data={filteredEvent} // Use filtered data
                customStyles={customStyles}
                pagination
                highlightOnHover
                responsive
              />
            )}
          </Card.Body>
        </Card>
        </Col>
       

        {/* <Col lg={12}>
                <Card>
                    <Card.Body>
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th>Organizer</th>
                                    <th>Event</th>
                                    <th>City</th>
                                    <th style={{ width: "150px" }} className="text-center">Status</th>
                                    <th style={{ width: "180px" }} className="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {events.map((event) => (
                                    <tr key={event.id}>
                                        <td>{event.first_name} {event.last_name}</td>
                                        <td>{event.name}</td>
                                        <td>{event.city}</td>
                                        <td className="text-center"> 
                                            <button onClick={() => handleOpenModal(event)} className={`btn ${event.status === "Enable" ? "btn-success" : "btn-danger"} btn-xxs`}>
                                                {event.status === "Enable" ? "Enable" : "Disable"}
                                            </button> 
                                        </td>
                                        <td className="text-center">
                                            <Link to={`/event-edit`} className="btn btn-primary btn-xxs me-2"> 
                                                <i className="fa-regular fa-pen-to-square"></i> 
                                            </Link>
                                            <Link to={`/event-details`} className="btn btn-primary btn-xxs me-2"> 
                                                <i className="fa-regular fa-eye"></i> 
                                            </Link>
                                            <button onClick={() => openDeleteModal(event)} className="btn btn-danger btn-xxs">
                                                <i className="fa-solid fa-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </Col> */}

        {/* Resell On/Off Modal */}
        <Modal show={resellShowModal} onHide={handleCloseResellModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              {resellModalType === "On" ? "On Ticket Resell" : "Off Ticket Resell"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to {resellModalType} tickets reselling of the event{" "}
            <strong>{selectedEvent?.name}</strong>?
          </Modal.Body>
          <Modal.Footer>
            <Button variant='light' onClick={handleCloseResellModal}>
              Cancel
            </Button>
            <Button
              className={`btn btn-${
                resellModalType === "On" ? "success" : "danger"
              }`}
              onClick={handleConfirmAction1}
              disabled={isProcessing}
            >
              {resellModalType === "On" ? "On" : "Off"}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Enable/Disable Modal */}
        <Modal show={showModal} onHide={handleCloseModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              {modalType === "enable" ? "Enable Event" : "Disable Event"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to {modalType} the event{" "}
            <strong>{selectedEvent?.name}</strong>?
          </Modal.Body>
          <Modal.Footer>
            <Button variant='light' onClick={handleCloseModal}>
              Cancel
            </Button>
            <Button
              className={`btn btn-${
                modalType === "enable" ? "success" : "danger"
              }`}
              onClick={handleConfirmAction}
              disabled={isProcessing}
            >
              {modalType === "enable" ? "Enable" : "Disable"}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Delete Confirmation Modal */}
        <Modal show={showDeleteModal} onHide={closeDeleteModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Delete Event</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to delete the event{" "}
            <strong>{selectedEvent?.name}</strong>?
          </Modal.Body>
          <Modal.Footer>
            <Button variant='light' onClick={closeDeleteModal}>
              Cancel
            </Button>
            <Button className='btn btn-danger' onClick={handleDeleteEvent} disabled={isProcessing}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>



        <Modal show={showFeesModal} onHide={closeFeesModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Fees for Event {selectedEvent?.name} </Modal.Title>
          </Modal.Header>
          <form onSubmit={formik.handleSubmit}>
          <Modal.Body>
            <h4 className="fw-bold text-primary mb-2">Platform Fees</h4>
              <div className="form-group mb-3">
                  <label>Platform Fee Type:</label>
                  <div className="input-group">
                    <select
                      className={`form-control ${formik.touched.platform_fees_type && formik.errors.platform_fees_type ? "is-invalid" : ""}`}
                      name="platform_fees_type"
                      value={formik.values.platform_fees_type}
                      onChange={formik.handleChange}
                    >
                      <option value="Percentage">Percentage</option>
                      <option value="Fixed">Fixed</option>
                    </select>
                    {formik.touched.platform_fees_type && formik.errors.platform_fees_type && (
                    <div className="invalid-feedback">{formik.errors.platform_fees_type}</div>
                    )}
                  </div>
              </div>
              {formik.values.platform_fees_type !== 'Fixed' && (
                <div className="form-group mb-3">
                    <label>Percentage Platform Fee:</label>
                    <div className="input-group">
                      <input
                        type="number"
                        min="0"
                        max="100"
                        className={`form-control ${
                          formik.touched.platform_fees_percentage && formik.errors.platform_fees_percentage ? "is-invalid" : ""
                        }`}
                        name="platform_fees_percentage"
                        value={formik.values.platform_fees_percentage}
                        onChange={formik.handleChange}
                      />
                      <div className="input-group-append">
                        <span className="input-group-text" style={{ padding: '12px 20px', borderRadius: '0 7px 7px 0', marginLeft: '0'}}>%</span>
                      </div>
                      {formik.touched.platform_fees_percentage && formik.errors.platform_fees_percentage && (
                      <div className="invalid-feedback">{formik.errors.platform_fees_percentage}</div>
                      )}
                    </div>
                </div>
              )}

              {formik.values.platform_fees_type !== 'Percentage' && (
                <div className="form-group mb-3">
                    <label>Fixed Platform Fee:</label>
                    <div className="input-group">
                      <input
                        type="number"
                        min="0"
                        className={`form-control ${
                          formik.touched.platform_fees_fixed && formik.errors.platform_fees_fixed ? "is-invalid" : ""
                        }`}
                        name="platform_fees_fixed"
                        value={formik.values.platform_fees_fixed}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.platform_fees_fixed && formik.errors.platform_fees_fixed && (
                      <div className="invalid-feedback">{formik.errors.platform_fees_fixed}</div>
                      )}
                    </div>
                </div>
              )}

            <h4 className="fw-bold text-primary mb-2">Primary Market Admin Fees</h4>

            <div className="form-group mb-3">
                <label>Percentage-Based Fee:</label>
                <div className="input-group">
                  <input
                    type="number"
                    min="0"
                    max="100"
                    className={`form-control ${
                      formik.touched.admin_fees_percentage && formik.errors.admin_fees_percentage ? "is-invalid" : ""
                    }`}
                    name="admin_fees_percentage"
                    value={formik.values.admin_fees_percentage}
                    onChange={formik.handleChange}
                  />
                  <div className="input-group-append">
                    <span className="input-group-text" style={{ padding: '12px 20px', borderRadius: '0 7px 7px 0', marginLeft: '0'}}>%</span>
                  </div>
                  {formik.touched.admin_fees_percentage && formik.errors.admin_fees_percentage && (
                  <div className="invalid-feedback">{formik.errors.admin_fees_percentage}</div>
                  )}
                </div>
            </div>
            <div className="form-group mb-3">
                <label>Max Order Amount for Percentage Fee:</label>
                <div className="input-group">
                  <input
                    type="number"
                    min="0"
                    className={`form-control ${
                      formik.touched.admin_fees_percentage_max_amount && formik.errors.admin_fees_percentage_max_amount ? "is-invalid" : ""
                    }`}
                    name="admin_fees_percentage_max_amount"
                    value={formik.values.admin_fees_percentage_max_amount}
                    onChange={formik.handleChange}
                  />
                  {formik.touched.admin_fees_percentage_max_amount && formik.errors.admin_fees_percentage_max_amount && (
                  <div className="invalid-feedback">{formik.errors.admin_fees_percentage_max_amount}</div>
                  )}
                </div>
            </div>
            <div className="form-group mb-3">
                <label>Fixed Fee (applies above max limit):</label>
                <div className="input-group">
                  <input
                    type="number"
                    min="0"
                    className={`form-control ${
                      formik.touched.admin_fixed_fees && formik.errors.admin_fixed_fees ? "is-invalid" : ""
                    }`}
                    name="admin_fixed_fees"
                    value={formik.values.admin_fixed_fees}
                    onChange={formik.handleChange}
                  />
                  {formik.touched.admin_fixed_fees && formik.errors.admin_fixed_fees && (
                  <div className="invalid-feedback">{formik.errors.admin_fixed_fees}</div>
                  )}
                </div>
            </div>

          <h4 className="fw-bold text-primary mb-3 mt-4 pt-3 border-top">Secondary Market Fees</h4>
            <div className="form-group mb-3">
                <label>Resell Ticket Admin Fee:</label>
                <div className="input-group">
                  <input
                    type="number"
                    min="0"
                    max="100"
                    className={`form-control ${
                      formik.touched.resale_admin_fees_percentage && formik.errors.resale_admin_fees_percentage ? "is-invalid" : ""
                    }`}
                    name="resale_admin_fees_percentage"
                    value={formik.values.resale_admin_fees_percentage}
                    onChange={formik.handleChange}
                  />
                  <div className="input-group-append">
                    <span className="input-group-text" style={{ padding: '12px 20px', borderRadius: '0 7px 7px 0', marginLeft: '0'}}>%</span>
                  </div>
                  {formik.touched.resale_admin_fees_percentage && formik.errors.resale_admin_fees_percentage && (
                  <div className="invalid-feedback">{formik.errors.resale_admin_fees_percentage}</div>
                  )}
                </div>
            </div>
             <div className="form-group mb-3">
                <label>Resell Ticket Organizer Fee:</label>
                <div className="input-group">
                  <input
                    type="number"
                    min="0"
                    max="100"
                    className={`form-control ${
                      formik.touched.resale_organizer_fees_percentage && formik.errors.resale_organizer_fees_percentage ? "is-invalid" : ""
                    }`}
                    name="resale_organizer_fees_percentage"
                    value={formik.values.resale_organizer_fees_percentage}
                    onChange={formik.handleChange}
                  />
                  <div className="input-group-append">
                    <span className="input-group-text" style={{ padding: '12px 20px', borderRadius: '0 7px 7px 0', marginLeft: '0'}}>%</span>
                  </div>
                  {formik.touched.resale_organizer_fees_percentage && formik.errors.resale_organizer_fees_percentage && (
                  <div className="invalid-feedback">{formik.errors.resale_organizer_fees_percentage}</div>
                  )}
                </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='light' onClick={closeFeesModal}>
              Cancel
            </Button>
            <Button variant="primary" type="submit" disabled={isProcessing}>
              Update
            </Button>
            
          </Modal.Footer>
          </form>

        </Modal>




        <Modal show={showBuyLimitModal} onHide={closeBuyLimitModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Per Transaction Buy Limit for Event {selectedEvent?.name} </Modal.Title>
          </Modal.Header>
          <form onSubmit={formik1.handleSubmit}>
          <Modal.Body>
            <h4 className="fw-bold text-primary mb-2">Per Transaction Tickets Buy Limit</h4>

            <div className="form-group mb-3">
                <div className="input-group">
                  <input
                    type="number"
                    min="0"
                    className={`form-control ${
                      formik1.touched.one_transaction_buy_limit && formik1.errors.one_transaction_buy_limit ? "is-invalid" : ""
                    }`}
                    name="one_transaction_buy_limit"
                    value={formik1.values.one_transaction_buy_limit}
                    onChange={formik1.handleChange}
                  />
                  {formik1.touched.one_transaction_buy_limit && formik1.errors.one_transaction_buy_limit && (
                  <div className="invalid-feedback">{formik1.errors.one_transaction_buy_limit}</div>
                  )}
                </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='light' onClick={closeBuyLimitModal}>
              Cancel
            </Button>
            <Button variant="primary" type="submit" disabled={isProcessing}>
              Update
            </Button>
            
          </Modal.Footer>
          </form>

        </Modal>
      </Fragment>
    );
};

export default EventsList;
